<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-2 pb-4 mb-3 border-bottom">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Booking Details</h3>
      </d-col>
    </d-row>

    <d-row>
      <d-col lg="12" class="mb-4">
        <d-card class="card-small mb-4">
          <d-card-body>
            <d-form>
              <d-col><label>ID: </label>{{ result.id }}</d-col>
              <d-col md="6" class="form-group">
                <label>Date: </label>
                <d-form-input type="text" id="feFirstName" v-model="result.date" readonly/>
              </d-col>
              <d-col>
                <tr v-for="(item, index) in result.childrens" :key="item.id">
                  <d-row>
                  <d-col><i class="far fa-trash-alt" @click="deleteRow(index)"></i></d-col>
                  <d-col>Children {{index + 1}}</d-col>  
                  <d-col>First Name: <d-form-input type="text" id="feFirstName" v-model="item.firstName"/></d-col>
                  <d-col>Last Name: <d-form-input type="text" id="feFirstName" v-model="item.lastName"/></d-col>
                  <d-col>Gender: <d-form-select v-model="item.gender" :options="options" /></d-col>
                  <d-col><i  @click="deleteRow(index)"></i></d-col>
                  </d-row>
                </tr>
              </d-col>         
              <d-col md="6" class="form-group"><label>Start Time: </label><d-form-input type="text" id="feFirstName" v-model="result.startTime" readonly/></d-col>
              <d-col md="6" class="form-group"><label>End Time: </label><d-form-input type="text" id="feFirstName" v-model="result.endTime" readonly/></d-col>
              <d-col><label>Status: </label>{{ result.bookingStatus }}</d-col>
              <d-col><d-button theme="primary" @click.prevent="updateBooking()">Update</d-button></d-col>
            </d-form>
          </d-card-body>
        </d-card>
        <d-card class="mb-1">
            <d-card-header class="px-3 py-2" role="tab">
                <d-btn block-level theme="secondary" href="#" v-d-toggle.accordion1>Accordion 1</d-btn>        
            </d-card-header>
            <d-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
                <d-card-body>
                <FullCalendar :options="calendarOptions" />
                </d-card-body>
            </d-collapse>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from "axios";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  props: { id: String },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        //dateClick: this.handleDateClick,
        eventClick: this.eventClick,
        events: [],
      },
      info: [],
      result: [],
      selected: '',
      options: [
        { value: 'Male', text: 'Male' },
        { value: 'Female', text: 'Female' },
      ]
    };
  },
  mounted: function () {
    this.onpageload();
  },
  created:function(){
    this.handleSubmit();
  },
  methods: {
    async onpageload() {
      await axios
        .get(process.env.VUE_APP_API+"api/staff/TimeSlot")
        .then((response) => {
          this.timeslot = response.data.result;
          this.timeslot.forEach(element => {
            element.result.forEach(x=>{
              var month = x.date.split('-')[1];
              month = month.length==1? '0'+ month : month;
              var date = x.date.split('-')[0]+ "-" + month + "-"+ x.date.split('-')[2];
              this.calendarOptions.events.push({groupId: `${x.id}`, title: `${x.startTime} - ${x.endTime}`, start: date });
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    eventClick: function(info) {
      axios
        .get(process.env.VUE_APP_API+"api/public_user/TimeSlot/" + info.event.groupId)
        .then((response) => {
          this.info = response.data.result;
          this.result.timeslotId = info.event.groupId;
          this.result.date = this.info.date;
          this.result.startTime = this.info.startTime;
          this.result.endTime = this.info.endTime;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleSubmit() {
      axios
        .get(
          process.env.VUE_APP_API+"api/staff/Booking/" +
            this.id
        )
        .then((response) => {
          this.result = response.data.result;
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateBooking() {
      axios
        .put(process.env.VUE_APP_API+"api/staff/Booking/" + this.result.id,{
          timeslotId: this.result.timeslotId,
          childrenIds: [this.result.childrens]
      })
    },
    deleteRow(index) {
        this.result.childrens.splice(index,1); 
    },
  },
};
</script>